export default __webpack_public_path__ + "static/media/headerImg.193a18b0.jpg";